import type { ProductDisplayData as Product } from '@eliadmin/core/src/api/products/types/product-types';

export function getCardVariantImages(images: Product['variant_images']) {
  return (images ?? []).filter(image => Boolean(image?.image?.url?.trim()));
}

export function getCardVariantUrl(productUrl: string, variantId: number) {
  if (!Number.isInteger(variantId) || variantId <= 0) return productUrl;

  const url = new URL(productUrl, 'https://bikeza.sk');
  url.searchParams.set('vid', String(variantId));
  return `${url.pathname}${url.search}${url.hash}`;
}
